// /Users/anandarajl/Desktop/my-app/src/redux/admin/userAccounts.thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdminUserAccounts,
  createAdminUserAccount,
  updateAdminUserCredentials,
  updateAdminUserStatus,
} from "../../api/admin/userAccounts.api";

/* =============================================================
   FETCH USERS
============================================================= */
export const fetchUserAccounts = createAsyncThunk(
  "admin/userAccounts/fetch",
  async ({ page = 1, limit = 10, search = "" } = {}, { rejectWithValue }) => {
    const res = await getAdminUserAccounts({ page, limit, search });

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res; // Returns { success, data, meta }
  }
);

/* =============================================================
   CREATE / PROVISION USER ACCOUNT
   Payload structure: { name, email, role_id, organization_id, is_active }
============================================================= */
export const createUserAccount = createAsyncThunk(
  "admin/userAccounts/create",
  async (userData, { rejectWithValue }) => {
    const res = await createAdminUserAccount(userData);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res; // Returns { success, message, data: { user_id, email } }
  }
);

/* =============================================================
   UPDATE CREDENTIALS / FORCE RESET PASSWORD
   Args shape: { userId, credentialData: { name, email, password } }
============================================================= */
export const updateUserCredentials = createAsyncThunk(
  "admin/userAccounts/updateCredentials",
  async ({ userId, credentialData }, { rejectWithValue }) => {
    const res = await updateAdminUserCredentials(userId, credentialData);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return {
      userId,
      ...credentialData, // Forward fields to allow state/reducer alignment (excluding raw passwords if necessary)
      message: res.message,
    };
  }
);

/* =============================================================
   UPDATE USER STATUS (Enable / Disable)
============================================================= */
export const updateUserStatus = createAsyncThunk(
  "admin/userAccounts/updateStatus",
  async ({ id, isActive }, { rejectWithValue }) => {
    const res = await updateAdminUserStatus(id, isActive);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return {
      id, // maps directly to user_org_roles.id
      is_active: isActive ? 1 : 0,
    };
  }
);